/**
 * Installs the documents store's HTML <-> blocks conversion (bodyHtmlCodec.js
 * says why it is a slot and not an import). Side-effect module: imported once
 * from src/index.js, and from setupTests.js for the unit tests. The Lexical
 * half loads on first use, so the editor stays out of the first bundle.
 */
import { setBodyHtmlCodec } from './bodyHtmlCodec';
import { seededBlockIds } from '../../../components/ui/lexicalBlocks';

setBodyHtmlCodec({
  toHtml: async (snapshot) => {
    const { blocksToHtml } = await import('../../../utils/docMarkdown/toHtml');
    return blocksToHtml((snapshot?.blocks || []).map((b) => b.node));
  },
  // The block ids an editor opening this HTML derives (its blockIdSeed is the document id).
  fromHtml: async (docId, html) => {
    const { htmlToBlocks } = await import('../../../utils/docMarkdown/fromHtml');
    const nodes = htmlToBlocks(html || '');
    const ids = seededBlockIds(docId, nodes.length);
    return { version: 1, blocks: nodes.map((node, i) => ({ id: ids[i], node })) };
  },
});
